module.exports = __webpack_public_path__ + "media/singit.b95e35cc.mp4";